import { render, staticRenderFns } from "./ruzhitiaogang.vue?vue&type=template&id=686d49e6&scoped=true"
import script from "./ruzhitiaogang.vue?vue&type=script&lang=js"
export * from "./ruzhitiaogang.vue?vue&type=script&lang=js"
import style0 from "./ruzhitiaogang.vue?vue&type=style&index=0&id=686d49e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686d49e6",
  null
  
)

export default component.exports